import config from '@/config'

export async function getOfferConfig (offerId) {
  window.remoteConfigOffers.settings.minimumFetchIntervalMillis = 60000
  await window.remoteConfigOffers.fetchAndActivate()
  const configuration = JSON.parse(window.remoteConfigOffers.getString(config.environment))
  return configuration[offerId]
}

export async function getDefaultConfig () {
  window.remoteConfig.settings.minimumFetchIntervalMillis = 60000
  await window.remoteConfig.fetchAndActivate()
  const configuration = JSON.parse(window.remoteConfig.getString(config.environment))
  return configuration
}

export async function getDefaultPlansInfo () {
  const configuration = await getDefaultConfig()
  const countryConfiguration = configuration.ptBr
  return countryConfiguration.offer ? countryConfiguration.offer.plans.items : countryConfiguration.default.plans.items
}
